import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../components-v2/Dialog';
import { styleSheet } from './styles';

interface IProps {
	automationName?: string;
	isArchive: boolean;
	isOpen: boolean;
	isProcessing?: boolean;
	onConfirm(): void;
	onRequestClose(): void;
}

export const AutomationArchiveConfirmModal: React.FC<IProps> = ({
	automationName,
	isArchive,
	isOpen,
	isProcessing,
	onConfirm,
	onRequestClose,
}) => {
	const isProcessingResolved = isProcessing ?? false;
	const title = isArchive ? 'Archive automation?' : 'Delete automation?';
	const confirmLabel = isArchive ? 'Yes, archive automation' : 'Yes, delete automation';
	const description = isArchive
		? 'Archiving this automation will remove it from the active list. You can still view archived automations later.'
		: 'This will permanently delete this automation. This action cannot be undone.';

	const handleOpenChange = (open: boolean) => {
		if (!open && !isProcessingResolved) {
			onRequestClose();
		}
	};

	return (
		<Dialog open={isOpen} onOpenChange={handleOpenChange}>
			<DialogPopup styles={[styleSheet.popup]} showCloseButton={!isProcessingResolved}>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p className={css(styleSheet.description)}>
						{automationName ? (
							<>
								{isArchive ? 'Archiving ' : 'Deleting '}
								<strong>{automationName}</strong>
								{isArchive
									? ' will remove it from the active list. You can still view archived automations later.'
									: ' is permanent and cannot be undone.'}
							</>
						) : (
							description
						)}
					</p>
				</DialogBody>
				<DialogFooter styles={[styleSheet.footer]}>
					<Button variant='secondary' onClick={onRequestClose} disabled={isProcessingResolved}>
						Cancel
					</Button>
					<Button
						variant={isArchive ? 'primary' : 'destructive'}
						onClick={onConfirm}
						disabled={isProcessingResolved}
						isLoading={isProcessingResolved}
					>
						{confirmLabel}
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
